import React from 'react';
import { Sunrise, Users, Dumbbell, Briefcase, GraduationCap, Shield } from 'lucide-react';

const WhoSection = () => {
  const audiences = [
    {
      icon: Sunrise,
      title: 'Early Risers',
      subtitle: 'Up before dawn',
      description: '5am starts need fuel that lasts until lunch. No time for complicated breakfasts.'
    },
    {
      icon: Users,
      title: 'Busy Parents',
      subtitle: 'Juggling everything',
      description: 'Your nutrition matters too. 60 seconds to ready means you actually eat.'
    },
    {
      icon: Dumbbell,
      title: 'Athletes & Movers',
      subtitle: 'Training hard',
      description: '9.5g protein per serving. Fuel your performance, support your recovery.'
    },
    {
      icon: Briefcase,
      title: 'Professionals',
      subtitle: 'Peak performance required',
      description: 'Back-to-back meetings need sustained energy. No crash, no brain fog.'
    },
    {
      icon: GraduationCap,
      title: 'Students',
      subtitle: 'Building futures',
      description: 'Brain fuel for focus and concentration. Learn better, perform better.'
    },
    {
      icon: Shield,
      title: 'Special Ops',
      subtitle: 'Whenever duty calls',
      description: 'Nights, days, rotating schedules. Reliable nutrition at any hour.'
    }
  ];

  return (
    <section id="who" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-4">
          <p className="text-[#8B6F47] text-sm tracking-widest uppercase mb-2">
            Universal Nutrition
          </p>
          <h2 className="text-4xl md:text-5xl font-bold text-[#2C2416] mb-6">
            Who is GUAG for?
          </h2>
          <p className="text-2xl text-[#5C4033] font-medium mb-16">
            Everyone. Because we all need quality nutrition to perform at our best.
          </p>
        </div>

        {/* Audience Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          {audiences.map((audience, index) => {
            const Icon = audience.icon;
            return (
              <div
                key={index}
                className="bg-[#F5F1E8] p-8 rounded-2xl hover:shadow-lg transition-shadow"
              >
                <div className="mb-4">
                  <Icon className="text-[#8B6F47]" size={40} strokeWidth={1.5} />
                </div>
                <h3 className="text-2xl font-bold text-[#2C2416] mb-2">
                  {audience.title}
                </h3>
                <p className="text-[#8B6F47] font-medium mb-3">
                  {audience.subtitle}
                </p>
                <p className="text-[#5C4033] leading-relaxed">
                  {audience.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* Footer CTA */}
        <div className="text-center bg-[#F5F1E8] rounded-2xl p-12">
          <h3 className="text-2xl font-bold text-[#2C2416] mb-3">
            Didn't see yourself?
          </h3>
          <p className="text-lg text-[#5C4033] mb-4">
            You belong here too.
          </p>
          <p className="text-[#8B6F47]">
            tag us <span className="font-semibold">@getguag</span> every journey deserves proper fuel.
          </p>
        </div>
      </div>
    </section>
  );
};

export default WhoSection;